import Link from "next/link";

import { Banner } from "@newsela/angelou";
import PropTypes from "prop-types";
import formatHrefToSupportLegacyLink from "@/utils/formatHrefToSupportLegacyLink";

import {
  bannerCss,
  bannerBodyCss,
  questionCss,
} from "./AdminConsoleRedirectMessageBanner.style";

const propTypes = {
  linkLabel: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

const AdminConsoleRedirectMessageBanner = ({ linkLabel, linkUrl, onClose }) => {
  return (
    <Banner
      bannerType={Banner.types.alert}
      __renderBody={(passedProps) => (
        <p
          className={passedProps.className}
          css={[passedProps.css, bannerBodyCss]}
        >
          <strong css={questionCss}> Can’t find the right person?</strong> Maybe
          they were assigned the wrong role. Try the &nbsp;
          <Link href={formatHrefToSupportLegacyLink(linkUrl)} legacyBehavior>
            <a href={linkUrl}>{linkLabel}</a>
          </Link>
          .
        </p>
      )}
      isDismissible
      onClose={onClose}
      __cssFor={{
        root: bannerCss,
      }}
    />
  );
};

AdminConsoleRedirectMessageBanner.propTypes = propTypes;

export default AdminConsoleRedirectMessageBanner;
